import NoteShow from "./NoteShow";
import NotesIndex from "./NotesIndex";
import getRootData from 'utils/getRootData';
import { UserInfo } from 'types/user_info';

interface RootData {
  userInfo: UserInfo;
}

interface NotesMainProps {
  id?: string;
  userInfo?: UserInfo | null;
}

const NotesMain = ({ id, userInfo: propUserInfo }: NotesMainProps = {}) => {
  const { userInfo: rootUserInfo } = getRootData<RootData>() ?? { userInfo: null };
  const userInfo = propUserInfo || rootUserInfo;

  return (
    <div className="mx-auto max-w lg:max-w-5xl bg-white p-6 pt-10 pb-20">
      {id ? <NoteShow currentNoteId={id} userInfo={userInfo} /> : <NotesIndex userInfo={userInfo} />}
    </div>
  );
};

export default NotesMain;
